import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import _isNil from "lodash/isNil";
import _find from "lodash/find";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { url } from '@datacamp/exercise-library-utils';
import fetch from 'cross-fetch';
import { getEndpoints } from '../lib/endpoints';
export class TeachApiClient {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }
  async getExercise(exerciseId, chapterHash, courseHash, baseData, validate) {
    const result = await fetch(url(this.endpoint, 'api', 'courses', courseHash, 'chapters', chapterHash, 'exercises'), {
      credentials: 'include',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const exercises = await result.json();
    const exercise = _find(exercises, {
      id: exerciseId
    });
    if (_isNil(exercise)) {
      throw new Error('The exercise does not exist');
    }
    const campusExercise = _objectSpread(_objectSpread({}, baseData), exercise);
    if (validate) {
      return validate(_get(exercise, 'type'), _get(exercise, 'version') || 'v0', campusExercise);
    }
    return campusExercise;
  }
  async getCourse(courseHash) {
    const result = await fetch(url(this.endpoint, 'api', 'courses', courseHash), {
      credentials: 'include',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const course = await result.json();
    return course;
  }
}
export const teachApiClient = environment => new TeachApiClient(getEndpoints(environment).TEACH_APP);